import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, MessageSquare, Mail } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-brown text-cream" data-id="element-33">
      <div className="container mx-auto px-4 py-12" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-35">
          <div className="md:col-span-1" data-id="element-36">
            <div className="mb-4" data-id="element-37">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/utRq69J5hAxbiGeb3Ckvjp/logo_jemi.png" alt="Jemi Baby Care Logo" className="h-16 w-auto" data-id="element-38" />
            </div>
            <p className="mb-4" data-id="element-39">From Bump to Baby and Beyond</p>
            <div className="flex space-x-4" data-id="element-40">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-cream hover:text-beige" data-id="element-41">
                <Instagram data-id="element-42" />
              </a>
              <a href="https://youtube.com/@jemibabycare" target="_blank" rel="noopener noreferrer" className="text-cream hover:text-beige" data-id="element-43">
                <Youtube data-id="element-44" />
              </a>
              <a href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="text-cream hover:text-beige" data-id="element-45">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-current" data-id="element-46">
                  <path d="M21 8V16C21 18.7614 18.7614 21 16 21H8C5.23858 21 3 18.7614 3 16V8C3 5.23858 5.23858 3 8 3H16C18.7614 3 21 5.23858 21 8Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-47" />
                  <path d="M10 12C8.34315 12 7 13.3431 7 15C7 16.6569 8.34315 18 10 18C11.6569 18 13 16.6569 13 15V9C13.3333 10 14.6 12 17 12" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-48" />
                </svg>
              </a>
            </div>
          </div>
          <div className="md:col-span-1" data-id="element-49">
            <h3 className="text-xl font-bold mb-4" data-id="element-50">Quick Links</h3>
            <ul className="space-y-2" data-id="element-51">
              <li data-id="element-52">
                <Link to="/" className="hover:text-beige" data-id="element-53">
                  Home
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/shop" className="hover:text-beige" data-id="element-55">
                  Shop
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/about" className="hover:text-beige" data-id="element-57">
                  About Us
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/blog" className="hover:text-beige" data-id="element-59">
                  Education Hub
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/faq" className="hover:text-beige" data-id="element-61">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-1" data-id="element-62">
            <h3 className="text-xl font-bold mb-4" data-id="element-63">Support</h3>
            <ul className="space-y-2" data-id="element-64">
              <li data-id="element-65">
                <Link to="/community" className="hover:text-beige" data-id="element-66">
                  Join Our Community
                </Link>
              </li>
              <li data-id="element-67">
                <Link to="/contact" className="hover:text-beige" data-id="element-68">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-1" data-id="element-69">
            <h3 className="text-xl font-bold mb-4" data-id="element-70">Contact</h3>
            <ul className="space-y-2" data-id="element-71">
              <li className="flex items-center space-x-2" data-id="element-72">
                <Mail size={16} data-id="element-73" />
                <span data-id="element-74">hello@jemibabycare.store</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-75">
                <Mail size={16} data-id="element-76" />
                <span data-id="element-77">doctor@jemibabycare.store</span>
              </li>
              <li className="flex items-center space-x-2" data-id="element-78">
                <MessageSquare size={16} data-id="element-79" />
                <a href="https://wa.me/2348065406312" target="_blank" rel="noopener noreferrer" className="hover:text-beige" data-id="element-80">
                  WhatsApp Business
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-cream/20 mt-8 pt-8 text-center" data-id="element-81">
          <p data-id="element-82">
            &copy; {new Date().getFullYear()} Jemi Baby Care. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;